import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import fetchRetry from '../fetchRetry';
import { CREATE_INTEGRATION_CREDENTIAL_SUCCESS } from './types';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const createIntegrationCredentialSuccess = payload => ({
  type: CREATE_INTEGRATION_CREDENTIAL_SUCCESS,
  payload,
});

/**
 * @param {String} orgID - sinatra org id
 * @param {Object} newCredential - user's input data from formik
 */

export const createIntegrationCredential =
  (orgID, newCredential) => async dispatch => {
    try {
      return await fetchRetry(
        `${baseURL}/psaps/${orgID}/authority-credentials`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newCredential),
        },
      )
        .then(checkStatus)
        .then(parseJSON)
        .then(response => {
          const {
            authority_account_id,
            created_at,
            credential_name,
            device_search_subdomain,
            data_source,
          } = newCredential;

          const createdCredential = {
            internal_id: response.id,
            authority_account_id,
            created_at,
            credential_name,
            device_search_subdomain,
            data_source,
            valid: true,
          };
          dispatch(createIntegrationCredentialSuccess(createdCredential));
          return response;
        });
    } catch (error) {
      return error;
    }
  };

export default createIntegrationCredential;
